<h2 class="dialog-title" mat-dialog-title>
  <ion-icon name="person-add-outline"></ion-icon>
  <span>Assign Contact</span>
  <span class="contact-count-badge">{{data.selectedCount.length}}</span>
</h2>

<mat-dialog-content class="dialog-body">

  <ion-radio-group (ionChange)="onSelectEvent($event)">
    @for (item of userList; track $index) {
    <div class="user-item">
      <ion-radio [value]="item" labelPlacement="start" class="user-radio">{{item.Name}}</ion-radio>
    </div>
    }
  </ion-radio-group>
</mat-dialog-content>

<div class="dialog-footer">
  <div class="footer-actions">
    <ion-button class="btn-cancel" (click)="cancel()">Close</ion-button>
    <ion-button class="btn-primary" [disabled]="!selectedValue" (click)="assign()">Assign</ion-button>
  </div>
</div>

<style>
  .dialog-title {
    display: flex !important;
    align-items: center;
    gap: 10px;
    background: var(--ion-color-secondary-shade) !important;
    color: #ffffff !important;
    padding: 14px 20px !important;
    margin: 0 !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    letter-spacing: 0.2px;
    line-height: 1.4 !important;
  }
  .dialog-title ion-icon {
    font-size: 19px;
    opacity: 0.85;
    flex-shrink: 0;
  }
  .contact-count-badge {
    margin-left: auto;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.35);
    border-radius: 12px;
    padding: 2px 10px;
    font-size: 13px;
    font-weight: 600;
    min-width: 24px;
    text-align: center;
  }
  .dialog-body {
    padding: 4px 0 !important;
    min-height: 80px;
    max-height: 340px;
    overflow-y: auto;
  }
  ion-radio-group { display: block; }
  .user-item {
    padding: 4px 18px;
    border-bottom: 1px solid #f0f3f7;
    transition: background 0.12s ease;
  }
  .user-item:last-child { border-bottom: none; }
  .user-item:hover { background: var(--ion-color-primary-tint); }
  .user-radio {
    --color: #aab4be;
    --color-checked: var(--ion-color-secondary-shade);
    width: 100%;
    padding: 10px 0;
    font-size: 14px;
    color: #3a3a4a;
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 16px;
    border-top: 1px solid #e8edf3;
    background: var(--ion-color-secondary);
  }
  .footer-actions { display: flex; align-items: center; gap: 8px; }
  .btn-cancel {
    --box-shadow: none !important;
    --background: transparent !important;
    --border-width: 1.5px !important;
    --border-style: solid !important;
    --border-color: var(--ion-color-secondary-shade) !important;
    --color: var(--ion-color-secondary-shade) !important;
    --border-radius: 6px !important;
    --padding-start: 14px;
    --padding-end: 14px;
    height: 34px;
    font-size: 13px;
    font-weight: 500;
    color: var(--ion-color-secondary-shade);
  }
  .btn-primary {
    --box-shadow: none !important;
    --background: var(--ion-color-secondary-shade) !important;
    --color: #ffffff !important;
    --border-radius: 6px !important;
    --padding-start: 16px;
    --padding-end: 16px;
    height: 34px;
    font-size: 13px;
    font-weight: 500;
    color: #ffffff;
  }
  .btn-primary[disabled] { opacity: 0.45; }
</style>